import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dataIconString' })
export class DataIconStringPipe implements PipeTransform {
  transform(value: string): string {
    let newString = '';
    if (value) {
      newString = value.replace(/&#/g, '0');
      newString = newString.replace(/;/g, '');
    }
    const checkValue = +newString;
    return String.fromCharCode(checkValue);
  }
}
